import React, { useEffect, useState } from "react";
import { FormControl, Select, MenuItem } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const AVAILABLE_MODELS = [
	{ value: "gpt-4.1", label: "GPT-4.1 (qualità completa, ultimo rilascio)" },
	{ value: "gpt-4.1-mini", label: "GPT-4.1-mini (veloce, economico)" },
	{ value: "gpt-4o", label: "GPT-4o (bilanciato, qualità alta)" },
	{ value: "gpt-4o-mini", label: "GPT-4o-mini (rapido, costo ridotto)" },
	{ value: "gpt-4o-mini-2024-07-18", label: "GPT-4o-mini 2024-07-18 (release specifica)" },
	{ value: "gpt-3.5-turbo", label: "GPT-3.5 Turbo (legacy)" },
];

const Gpt = ({ onClose }) => {
	const [selectedModel, setSelectedModel] = useState("gpt-4o");
	const [activeModel, setActiveModel] = useState("gpt-4o");
	const navigate = useNavigate();

	useEffect(() => {
		const stored = localStorage.getItem("preferredModel");
		const fallback = "gpt-4o";
		const model = stored && AVAILABLE_MODELS.find((m) => m.value === stored) ? stored : fallback;
		setSelectedModel(model);
		setActiveModel(model);
	}, []);

	const handleSave = (model) => {
		localStorage.setItem("preferredModel", model);
		setActiveModel(model);
		toast.success(`Modello impostato: ${model}`);
	};

	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget) {
			onClose ? onClose() : navigate(-1);
		}
	};

	const selectorBackground = "var(--brand-light)";

	return (
		<div
			className="fixed inset-0 z-50 flex items-center justify-center p-4"
			style={{
				background: "rgba(12, 19, 31, 0.55)",
				backdropFilter: "blur(8px)",
			}}
			onClick={handleOverlayClick}
		>
			<div className="w-full max-w-2xl p-0 shadow-none bg-transparent">
				<FormControl fullWidth>
					<Select
						labelId="model-select-label"
						id="model-select"
						value={selectedModel}
					onChange={(e) => {
						const next = e.target.value;
						setSelectedModel(next);
						if (next !== activeModel) {
							handleSave(next);
						}
					}}
						MenuProps={{
							PaperProps: {
								sx: {
									maxHeight: 260,
									color: "var(--brand-dark)",
									backgroundColor: selectorBackground,
									borderRadius: 16,
									boxShadow: "0 10px 24px rgba(15,23,42,0.15)",
									"& .MuiMenuItem-root": {
										backgroundColor: selectorBackground,
										color: "var(--brand-dark)",
										"&:hover": {
											backgroundColor: "rgba(35, 100, 174, 0.12)",
										},
										"&.Mui-selected": {
											backgroundColor: "rgba(35, 100, 174, 0.26)",
										},
										"&.Mui-selected:hover": {
											backgroundColor: "rgba(35, 100, 174, 0.32)",
										},
									},
								},
							},
						}}
						sx={{
							color: "var(--brand-dark)",
							"& .MuiSvgIcon-root": { color: "var(--brand-dark)" },
							"& fieldset": { borderColor: "var(--brand-dark)" },
							"&:hover fieldset": { borderColor: "var(--brand-dark)" },
							"&.Mui-focused fieldset": { borderColor: "var(--brand-dark)" },
							background: selectorBackground,
							borderRadius: "18px",
							boxShadow: "0 10px 24px rgba(15,23,42,0.15)",
							minHeight: "64px",
						}}
					>
						{AVAILABLE_MODELS.map((m) => (
							<MenuItem key={m.value} value={m.value}>
								<div className="flex flex-col text-[var(--brand-dark)]">
									<span className="font-medium">{m.value}</span>
									<span className="text-sm text-[var(--brand-dark)]">{m.label}</span>
								</div>
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</div>
		</div>
	);
};

export default Gpt;
